import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const SaveSkills = async (Skills, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      let Payload = {
        skillID: Skills.skillID,
        skillName: Skills.skillName,
        isActive: true,
      };
      const response = await fetch(`${dev_baseUrl}/Skills/save`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accesstoken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(Payload),
      });

      const data = await response.json();
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else {
        return data;
      }
    } catch (error) {
      console.error("Network error:", error);
      return {
        isError: true,
        message: "An error occurred. Please try again later.",
        error: error,
      };
    }
  } else {
    console.warn("Access token is not available.");
    return { form: "Access token is missing." };
  }
};

export const GetSkills = async (skillID, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {        
      
      const response = await fetch(`${dev_baseUrl}/Skills/get/${skillID}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        }
      });
      
      const data = await response.json();                           

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else {      
        return data;
      }       
    } catch (error) {
      console.error('Network error:', error);
      return { isError: true, message: 'An error occurred. Please try again later.', error: error };
    }
  } else {
    console.warn('Access token is not available.');
    return { isError: true, message: 'Access token is missing.' };
  }
};

//DeleteSkill
export const DeleteSkill = async (id,navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/Skills/delete/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else if(response.ok && !data.isError ){      
        return data;
      } 
      else {
        console.error('Server Error:',data.message);
        return data;
      }
    }
    catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
}

export const SoftDeleteSKill = async (id,navigate) => {
  const accesstoken = getToken();

  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/Skill/softDelete/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        

    if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
    } else if(response.ok && !data.isError ){      
      return data;
    } 
    else {
      console.error('Server Error:',data.message);
      return data;
    }
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};
